import { combineReducers } from 'redux';

const emptyValidationFile = { file: [], error: 0, info: [], summary: [] };

const file = (state = emptyValidationFile, action) => {
    switch (action.type) {
        case "VALIDATION_FILE":
            return { ...state, file: action.payload };
        case "SUMMARY_FILE":
            return { ...state, summary: action.payload };
        case "VALIDATION_INFO":
            return { ...state, info: action.payload };
        case "VALIDATION_ERROR":
            return { ...state, error: action.payload };
        case "VALIDATION_RESET":
            return { ...emptyValidationFile };
        default:
            return state;
    }
}
const PDFfile = (state = { file: '' }, action) => {
    switch (action.type) {
        case "PDF_FILE":
            return { ...state, file: action.payload };
        default:
            return state;
    }
}

const fileLoading = (state = false, action) => {
    switch (action.type) {
        case "REPORT_LOADING":
            return true;
        case "REPORT_DONE":
            return false;
        default:
            return state;
    }
}

const filePoints = (state = [], action) => {
    switch (action.type){
        case "SET_FILE_POINTS":
            return action.payload;
        default:
            return state;
    }
}

export default combineReducers({
    file,
    fileLoading,
    PDFfile,
    filePoints,
});
